import axios, { AxiosInstance } from 'axios'
import { getBaseUrl } from '../api.utils'
import { Batch } from '../../types'
import { Api } from '../api.types'

export class AxiosApi implements Api {
  #instance: AxiosInstance
  #debug = false

  constructor(platform: string, publicApiKey: string, acceptLanguage?: string, debug = false, apiUrl?: string) {
    this.#debug = debug
    this.#instance = axios.create({
      baseURL: apiUrl ?? getBaseUrl(publicApiKey),
      // eslint-disable-next-line @typescript-eslint/naming-convention
      headers: { 'X-Platform': platform, 'public-api-key': publicApiKey, 'accept-language': acceptLanguage },
      timeout: 60000,
    })
  }

  sendBatch(batches: Batch[]): Promise<null> {
    if (this.#debug) {
      console.dir(batches, { depth: null })
    }

    return this.#instance
      .post('/v1/sdk/event-log/publish', { batch: batches })
      .then(({ data }) => data)
  }

  sendMetricsBatch(batches: Batch[]): Promise<null> {
    if (this.#debug) {
      console.dir(batches, { depth: null })
    }

    return this.#instance
      .post('/v1/sdk/performance/publish', { batch: batches })
      .then(({ data }) => data)
  }

  getInstances() {
    return this.#instance
  }
}
